import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ContactForm } from "@/components/forms/ContactForm";
import { GlobalError } from "@/global-error";
import { NotFound } from "@/not-found";
import { Container } from "@/components/ui/container";

export const Route = createFileRoute("/_home/contact")({
  component: ContactPage,
  notFoundComponent: NotFound,
  errorComponent: GlobalError,
});

function ContactPage() {
  return (
    <Container className="col-span-12">
      <Card className="col-span-12 sm:col-span-10 sm:col-start-2 md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
        <CardHeader className="pb-0">
          <CardTitle asHeading data-testid="contact-title">
            Contact
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <ContactForm />
        </CardContent>
      </Card>
    </Container>
  );
}
